module.exports = __webpack_public_path__ + "static/media/bariol_bold.278934679a31a018a2b7294b41d14f6a5f2209ea731c2046b98117b6249799ee.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bariol_bold.woff
// module id = 2546
// module chunks = 204